import React, {useContext,useEffect} from 'react';
import { GlobalContext } from "../../handlers/GlobalContext";

// File imported
import SideHeader from "../../components/SideHeader";
import ContentAccountSettingsPage from "../../templates/account";
import Header from "../../components/header/HeaderOne";
import FooterThree from "../../components/footer/FooterThree";

const AccountSettings = () => {
    const [ state, dispatch] = useContext(GlobalContext);
    return (
        <div>

            <Header classes={'position-static'}/>
            <SideHeader mobile={true}/>
            <ContentAccountSettingsPage/>
            <FooterThree position={'fixed'}/>
        </div>
    );
};

export default AccountSettings;
